import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { GenerateExcelComponent } from './generate-excel/generate-excel.component';
import { BasePageComponent } from '../../../core/classes/base-page';
import { HelpersService } from '../../../core/services/helpers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../../../core/services/loading.service';
import { AuthService } from '../../../core/services/auth.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { ReportService } from '../../../core/api/report.service';
import { FileService } from '../../../core/api/file.service';
import { AllComponent } from './all/all.component';
import { ReimbursementComponent } from './reimbursement/reimbursement.component';
import { CashAdvanceComponent } from './cash-advance/cash-advance.component';
import { PositionService } from '../../../core/api/position.service';
@Component({
  selector: 'app-report',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatDividerModule,
    MatTabsModule,
    MatMenuModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AllComponent,
    ReimbursementComponent,
    CashAdvanceComponent,
  ],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss',
})
export class ReportComponent {
  tabIndex = 0;
  currentUser: any;
  positions: any[] = [];

  constructor(
    public authService: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private positionService: PositionService
  ) {
    this.currentUser = this.authService.getLoggedUser();
  }

  ngOnInit(): void {
    this.positionService
      .getAllData()
      .then((res) => {
        this.positions = res;
        this.validateReportAccess();
      })
      .catch(() => {
        this.validateReportAccess();
      });
  }

  private validateReportAccess(): void {
    if (!this.authService.canAccessReport(this.currentUser, this.positions)) {
      this.helpers.sbError('Anda tidak memiliki akses ke menu report');
      this.router.navigate(['/dashboard/home']);
    }
  }
}
